export default "__VITE_ASSET__D4qunuTf__"